import { isBusiness250Plan } from '@/shared/lib/billing/isBusiness250Plan';
import { MixpanelEvents } from '@/shared/thirdParty/mixpanel';
import { PaymentInterval, Plan, Price, Products } from '@/shared/types/Billing';

export const trackBusinessPricingClick = (
  plan: Plan,
  priceId: Price['id'],
  experiment: Products['pricing_experiment'],
  source: 'legacyPricingPage' | 'pricingPage' | 'trialModal' | 'trialPaywallExperiment',
) => {
  const price = plan.prices.find((item) => item.id === priceId);
  if (
    !isBusiness250Plan(plan) ||
    !price?.recurring ||
    !experiment?.eligible ||
    !experiment.variant ||
    (price.experiment_variant ?? 'C') !== experiment.variant
  ) {
    return;
  }

  MixpanelEvents.pricingBusinessGetStartedClick({
    billing_period: price.recurring.interval,
    currency: price.currency.toUpperCase(),
    minutes_per_month: Number(plan.metadata.bundle_value),
    price_amount: price.unit_amount / 100,
    price_id: price.id,
    pricing_experiment_key: experiment.key,
    pricing_experiment_variant: experiment.variant,
    pricing_offer: 'business_250',
    product_id: plan.id,
    source,
    subscription: `${plan.name} ${price.recurring.interval === PaymentInterval.Year ? 'Annual' : 'Monthly'}`,
  });
};
